<template>
  <div hidden />
</template>
<script>
export default {
  name: 'hidden-field',
  data() {
    return {
      value: '',
      dependentdata: {}
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    params: {
      field: {
        type: Object
      }
    },
    formdata: {
      field: {
        type: Object,
        required: true,
      }
    },

  },

  created() {
    this.getValues()
  },

  watch: {
    formdata: {
      deep: true,
      handler: async function(newVal) {
        if (this.field.depends !== '' && this.field.depends !== undefined) {
          if ( typeof this.dependentdata[this.field.depends] === 'object'){
            if (this.field.depends in newVal) {
              if (JSON.stringify(this.dependentdata[this.field.depends]) !== JSON.stringify(newVal[this.field.depends])) {
                this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
                await this.getValues()
              }
            }else{
              this.value = undefined
            }
          }else {
            if (this.field.depends in newVal) {
              if (this.dependentdata[this.field.depends] !== newVal[this.field.depends]) {
                this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
                await this.getValues()
              }
            }else{
              this.value = undefined
            }
          }
        }
      }
    }
  },

  methods: {
    checkDepends() {
      console.log('checkDepends', this.field)
      if (this.field.depends === undefined || this.field.depends === "") {
        this.fetchOptions()
      }
    },
    async getValues() {
      let config = {
        params: {
          legend: true,
          ...this.params,
          ...this.formdata,
          formdata: this.formdata,
          params: this.params
        }
      }

      const response = await this.$http.get(this.field.uri, config)
      var payload = response.data[this.field.key]
      this.value = payload.value
      this.$parent.updateValue(this.field.key, this.value)


    },
  }
}
</script>
